<template>
    <fieldset>
        <legend>{{Language.say('settings.layout.view_mode')}}</legend>
        <div class="control-group">
            <ul class="control radio-group theme-selection">
                <li
                    v-for="(theme, theme_index) in theme_list"
                    :key="theme_index"
                    :class="theme.name">
                    <input
                        type="radio"
                        :id="`theme${theme_index}`"
                        :checked="layout_controller.theme_option === theme.slug"
                        tabindex="-1">
                    <label
                        @click.prevent="onSetTheme(theme.slug)"
                        :for="`theme${theme_index}`"
                        tabindex="0">
                            {{Language.say(`settings.layout.${theme.name}_mode`)}}
                    </label>
                </li>
            </ul>
        </div>
    </fieldset>
</template>

<script setup>
  import {defineProps} from 'vue';
  import Language from '@/js/Shared/Language/Language';

  const props = defineProps({
    layout_controller: Object
  })

  const theme_list = [
    {
        name: 'light',
        slug: 'light-theme',
    },
    {
        name: 'dark',
        slug: 'dark-theme',
    },
    {
        name: 'default',
        slug: 'automatic',
    }
  ];

  const onSetTheme = (theme) => {
    props.layout_controller.theme_option = theme;
  }
</script>